module.exports = __webpack_public_path__ + "static/logo-footer-126c63684a7c0ed74cfc561295ea277d.svg";